module.exports = __webpack_public_path__ + "static/media/newbie.edc42049.svg";